import { clientMount } from '@vp/ubik-fragment-react';
import type { MountWithRootOptions } from '@vp/ubik-fragment-types';
import {
  WhiteLabelPreference,
  type Props,
} from '../components/white-label-preference';
import { type FragmentWrapperProps, FragmentWrapper } from '../FragmentWrapper';

export const mount: MountWithRootOptions<Props & FragmentWrapperProps> = async (
  rootElement,
  { localizations, ...rest },
  rootOptions
) => {
  return clientMount(
    <FragmentWrapper localizations={localizations}>
      <WhiteLabelPreference {...rest} />
    </FragmentWrapper>,
    rootElement,
    rootOptions
  );
};
